import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLanguageContext } from "../../context/LanguageContext";
import FileHelper from "../../helpers/FileHelper";
import PdfViewer from "../pdfViewer/PdfViewer";
import {
  StyledCloseButton,
  StyledFilePreview,
  StyledMiniPreview,
  StyledOverlay,
  StyledPreview,
  StyledPreviewContainer,
} from "./FilePreviewStyles";
import { faFilePdf, faVideo } from "@fortawesome/free-solid-svg-icons";

function FilePreviewView({
  path,
  containerRef,
  showPreview,
  onClose,
  onOpen,
  children,
  disabled,
  pathType,
  onContainerScroll,
  onVideoEnd,
  onLoaded,
  closeable = true,
}) {
  const { translate } = useLanguageContext();

  return (
    <>
      <StyledFilePreview onClick={onOpen} disabled={disabled}>
        {children ?? (
          <>
            {pathType === "image" && (
              <StyledMiniPreview
                src={FileHelper.apiPath(path)}
                alt={"File preview"}
              />
            )}

            {pathType === "video" && (
              <StyledMiniPreview as={FontAwesomeIcon} icon={faVideo} />
            )}

            {pathType === "attachment" && (
              <StyledMiniPreview as={FontAwesomeIcon} icon={faFilePdf} />
            )}
          </>
        )}
      </StyledFilePreview>

      {showPreview && (
        <StyledOverlay>
          <StyledPreviewContainer
            style={{
              alignItems: pathType === "attachment" ? "initial" : "center",
            }}
            ref={containerRef}
            onScroll={onContainerScroll}
          >
            {pathType === "image" && (
              <StyledPreview
                src={FileHelper.apiPath(path)}
                alt={FileHelper.apiPath(path)}
                onLoad={onLoaded}
              />
            )}

            {pathType === "video" && (
              <StyledPreview
                as="video"
                controls={false}
                autoPlay
                onEnded={onVideoEnd}
              >
                <source src={FileHelper.apiPath(path)} />
              </StyledPreview>
            )}

            {pathType === "attachment" && (
              <PdfViewer
                url={FileHelper.apiPath(path, true)}
                onLoaded={onLoaded}
              />
            )}
          </StyledPreviewContainer>

          <StyledCloseButton
            style={{ display: "block" }}
            onClick={onClose}
            disabled={!closeable}
          >
            {translate("eva.main.general.close")}
          </StyledCloseButton>
        </StyledOverlay>
      )}
    </>
  );
}

export default FilePreviewView;
